import { DateTime } from 'luxon';

/**
 * Nested certificate/record relations may be missing on a valid empty row.
 * Non-array values are not iterated (avoids crash); they are not rewritten as a fake list payload.
 */
export function asRowList(value) {
  return Array.isArray(value) ? value : [];
}

export function formatDeactivationDateLabel(rowData, dateFmt) {
  const d = rowData?.deactivation_date;
  if (!d) return '—';
  const dt = DateTime.fromISO(d);
  return dt.isValid ? dt.toFormat(dateFmt) : '—';
}

/**
 * Direct ISO on the row, else first tree child. Missing/empty children is a valid empty state.
 * @returns {string|null} formatted date, or null when the UI should show the empty placeholder
 */
export function formatTreeValidityLabel(rowData, field, dateFmt) {
  const direct = rowData?.[field];
  if (direct) {
    const dt = DateTime.fromISO(direct);
    return dt.isValid ? dt.toFormat(dateFmt) : null;
  }
  const first = asRowList(rowData?._children)[0];
  if (first?.[field]) {
    const dt = DateTime.fromISO(first[field]);
    return dt.isValid ? dt.toFormat(dateFmt) : null;
  }
  return null;
}

export function protocolFileList(rowData) {
  const own = asRowList(rowData?.files);
  if (own.length) return own;
  return asRowList(asRowList(rowData?._children)[0]?.files);
}
